if (!customElements.get('pawly-bundle-shopping')) {
  customElements.define('pawly-bundle-shopping', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = this.closest('form');
      if (!this.form) return;
      this.ready = true;
      this.scope = this.closest('product-info') || this.form;
      this.variants = JSON.parse(this.querySelector('[data-main-variants]').textContent);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-variant]')) this.updateAddon(event.target.closest('[data-addon]'));
        this.update();
      }, options);
      const updateMain = event => {
        if (!this.contains(event.target)) queueMicrotask(() => this.update());
      };
      this.scope.addEventListener('change', updateMain, options);
      this.scope.addEventListener('input', updateMain, options);
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.target.matches?.('input[name="id"], input[name="quantity"]'))) this.update();
      });
      this.observer.observe(this.scope, { subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.quantityUpdate) {
        this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.update());
      }
      this.querySelectorAll('[data-addon]').forEach(row => this.updateAddon(row));
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.unsubscribeQuantity?.();
      this.unsubscribeQuantity = undefined;
      this.ready = false;
    }
    mainSelection() {
      const id = this.form?.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(variant => String(variant.id) === String(id));
      const input = this.form?.querySelector('[name="quantity"]') || this.scope?.querySelector('input[name="quantity"]');
      const quantity = Number(input?.value || 1);
      return { variant, quantity };
    }
    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
    }
    updateAddon(row) {
      const option = row.querySelector('[data-variant]').selectedOptions[0];
      if (!option) return;
      const quantity = Number(option.dataset.min || 1);
      row.querySelector('[data-line-price]').textContent = this.money(Number(option.dataset.price) * quantity);
      const note = row.querySelector('[data-min-quantity]');
      note.hidden = quantity <= 1;
      note.textContent = `${this.dataset.labelQuantity}: ${quantity}`;
      const image = row.querySelector('img');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
    }
    selectedAddons() {
      return [...this.querySelectorAll('[data-addon]')].filter(row => row.querySelector('.pcb-check').checked).map(row => {
        const select = row.querySelector('[data-variant]');
        const option = select.selectedOptions[0];
        const quantity = Number(option?.dataset.min || 1);
        return { id: select.value, price: Number(option?.dataset.price || 0), quantity, valid: !!option && !option.disabled && !!select.value && Number.isInteger(quantity) && quantity > 0 };
      });
    }
    selectionError() {
      return this.selectedAddons().some(addon => !addon.valid) ? this.dataset.labelError : '';
    }
    update() {
      if (!this.form) return;
      const main = this.mainSelection();
      const addons = this.selectedAddons();
      const total = this.money((main.variant?.price || 0) * (Number.isFinite(main.quantity) ? main.quantity : 0) + addons.reduce((sum, addon) => sum + addon.price * addon.quantity, 0));
      const totalElement = this.querySelector('[data-total]');
      if (totalElement.textContent !== total) totalElement.textContent = total;
      const container = this.querySelector('[data-express-items]');
      const signature = JSON.stringify(addons.filter(addon => addon.valid).map(({ id, quantity }) => [id, quantity]));
      if (container.dataset.selection === signature) return;
      container.dataset.selection = signature;
      const inputs = [];
      addons.filter(addon => addon.valid).forEach((addon, index) => {
        for (const [field, value] of [['id', addon.id], ['quantity', addon.quantity]]) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `shopify-additional-items[${index + 1}][${field}]`;
          input.value = String(value);
          inputs.push(input);
        }
      });
      container.replaceChildren(...inputs);
    }
    appendItems(formData) {
      const addons = this.selectedAddons();
      for (const name of new Set(formData.keys())) {
        if (name.startsWith('shopify-additional-items[')) formData.delete(name);
      }
      if (!addons.length) return;
      const id = formData.get('id');
      const quantity = formData.get('quantity') || String(this.mainSelection().quantity);
      const entries = [...formData.entries()];
      formData.delete('id');
      formData.delete('quantity');
      formData.delete('selling_plan');
      for (const [name] of entries) {
        if (/^properties\[.+\]$/.test(name)) formData.delete(name);
      }
      formData.append('items[0][id]', id);
      formData.append('items[0][quantity]', quantity);
      for (const [name, value] of entries) {
        const property = name.match(/^properties\[(.+)\]$/);
        if (property) formData.append(`items[0][properties][${property[1]}]`, value);
        if (name === 'selling_plan' && value) formData.append('items[0][selling_plan]', value);
      }
      addons.forEach((addon, index) => {
        formData.append(`items[${index + 1}][id]`, addon.id);
        formData.append(`items[${index + 1}][quantity]`, String(addon.quantity));
      });
    }
  });
}


if (!customElements.get('pawly-bundle-manager')) {
  customElements.define('pawly-bundle-manager', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.main = this.closest('main');
      if (!this.main) return;
      this.abort = new AbortController();
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = undefined;
          if (this.isConnected) this.mount();
        });
      };
      const relevant = node => node.nodeType === 1 && (
        node.matches('product-info, product-form-component, form, .product-form__buttons, .add-to-cart-button-container, pawly-bundle-shopping') ||
        node.querySelector('product-info, product-form-component, form, .product-form__buttons')
      );
      this.observer = new MutationObserver(records => {
        if (records.some(record => {
          if (record.target.closest?.('pawly-bundle-shopping, pawly-bundle-manager')) return false;
          return [...record.addedNodes, ...record.removedNodes].some(relevant);
        })) schedule();
      });
      this.observer.observe(this.main, { childList: true, subtree: true });
      const options = { signal: this.abort.signal };
      this.main.addEventListener('product-info:loaded', schedule, options);
      document.addEventListener('shopify:section:load', schedule, options);
      this.mount();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.observer = undefined;
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = undefined;
    }

    mount() {
      const scope = [...this.main.querySelectorAll('.main-product-information product-info')]
        .find(node => node.dataset.productId === this.dataset.productId && node.dataset.updateUrl === 'true');
      if (!scope) return;
      const form = scope.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      const buttons = form?.querySelector('.product-form__buttons');
      const submit = buttons?.querySelector('button.add-to-cart-button[name="add"]');
      if (!form || !buttons || !submit) return;
      let anchor = submit;
      while (anchor.parentElement && anchor.parentElement !== buttons) anchor = anchor.parentElement;
      if (anchor.parentElement !== buttons) return;
      const source = this.querySelector('template')?.content.querySelector('pawly-bundle-shopping');
      const existing = [...form.querySelectorAll('pawly-bundle-shopping')];
      if (!source) {
        existing.forEach(node => node.remove());
        this.bundle = undefined;
        return;
      }
      let bundle = existing.find(node => node.hasAttribute('data-pawly-bundle-global') && node.dataset.productId === this.dataset.productId);
      existing.filter(node => node !== bundle).forEach(node => node.remove());
      if (!bundle) {
        const selections = new Map();
        if (this.bundle?.dataset.productId === this.dataset.productId) {
          this.bundle.querySelectorAll('[data-addon]').forEach(row => {
            selections.set(row.dataset.addonId, {
              checked: row.querySelector('.pcb-check').checked,
              variant: row.querySelector('[data-variant]').value
            });
          });
        }
        bundle = source.cloneNode(true);
        bundle.querySelectorAll('[data-addon]').forEach(row => {
          const saved = selections.get(row.dataset.addonId);
          if (!saved) return;
          const select = row.querySelector('[data-variant]');
          if ([...select.options].some(option => option.value === saved.variant && !option.disabled)) {
            select.value = saved.variant;
            row.querySelector('.pcb-check').checked = saved.checked;
          }
        });
        buttons.insertBefore(bundle, anchor);
      } else if (bundle.parentElement !== buttons || bundle.nextElementSibling !== anchor) {
        buttons.insertBefore(bundle, anchor);
      }
      this.bundle = bundle;
    }
  });
}
